import type { Game } from 'chessboard/model/game/types';

/**
 * Determine if the given node is the on the last line in its parent's lines array
 */
export function isOnLastLineOfParentNode(
  node: Game.Move.Node,
  parentNode: Game.Move.Node,
): boolean {
  return parentNode.lines ? node.ids.line === parentNode.lines[parentNode.lines.length - 1] : false;
}
